<template>
  <div class="cloud-path-content">
    <div class="program-content">
      <div class="program-content-header">
        <div>
          <a-icon type="code" style="margin-right: 4px" />
          {{ $t('page_dnc_station_file_internal_storage') }}
        </div>
      </div>
      <div id="program-content-list" class="program-content-list">
        <source-table
          :scrollY="programScrollY"
          :columns="programColumns"
          :dataSource="programList"
          :loading="loading"
        ></source-table>
      </div>
    </div>

    <!-- <div class="documents-content">
      <div class="documents-content-header">
        <div><a-icon type="wallet" style="margin-right: 4px" />{{$t('page_dnc_station_file_gateway_storage')}}</div>
      </div>
      <div id="documents-content-list" class="documents-content-list">
        <source-table
          :scrollY="fileScrollY"
          :columns="fileColumns"
          :dataSource="fileList"
          :loading="loading"
        ></source-table>
      </div>
    </div> -->
    <preview-modal
      :visible="previewVisible"
      :data="previewData"
      @close="closePreview"
    ></preview-modal>
    <cnc-modal
      :visible="cncVisible"
      :name="cncName"
      :content="cncContent"
      @close="closeCncPreview"
    ></cnc-modal>
  </div>
</template>

<script>
import { downloadGET } from '@/api/api'
import { downloadFile } from '@/utils'
import PreviewModal from '../../components/PreviewModal.vue'
import CncModal from '../../components/CncModal.vue'
import SourceTable from './File/SourceTable.vue'
import { DncApiServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'
import { columns } from './data'
const dasp = new DncApiServiceProxy()

export default {
  components: {
    SourceTable,
    PreviewModal,
    CncModal
  },
  computed: {
    programColumns() {
      const list = columns.map((res) => {
        let item = {
          ...res,
          title: this.$t(res.title)
        }
        if (res.dataIndex === 'actions') {
          item.customRender = (_, record) => {
            return (
              <div>
                <a-popconfirm
                  title={this.$t('page_transport_directory_sure_to_delete_the_file')}
                  onConfirm={() => this.handleCncDelete(record)}
                  okText={this.$t('ok')}
                  cancelText={this.$t('cancel')}
                >
                  <a class="del-color">{this.$t('delete')}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handleCncDownload(record)
                  }}
                >
                  {this.$t('page_my_document_download')}
                </a>
                <a-divider type="vertical" />
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handleCncPrev(record)
                  }}
                  disabled={record.suffix === 'zip'}
                >
                  {this.$t('preview')}
                </a>
              </div>
            )
          }
        }
        return item
      })
      return list
    },
    fileColumns() {
      const list = columns.map((res) => {
        let item = {
          ...res,
          title: this.$t(res.title)
        }
        if (res.dataIndex === 'actions') {
          item.customRender = (_, record) => {
            return (
              <div>
                <a-popconfirm
                  title={this.$t('page_transport_directory_sure_to_delete_the_file')}
                  onConfirm={() => this.handleDelete(record)}
                  okText={this.$t('ok')}
                  cancelText={this.$t('cancel')}
                >
                  <a class="del-color">{this.$t('delete')}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handleDownload(record)
                  }}
                >
                  {this.$t('page_my_document_download')}
                </a>
                <a-divider type="vertical" />
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handlePrev(record)
                  }}
                  disabled={record.suffix === 'zip'}
                >
                  {this.$t('preview')}
                </a>
              </div>
            )
          }
        }
        return item
      })
      return list
    }
  },
  data() {
    return {
      programList: [],
      fileList: [],
      programRowKeys: [],
      fileRowKeys: [],
      programScrollY: 0,
      fileScrollY: 0,
      previewData: {},
      previewVisible: false,
      loading: false,
      cncVisible: false,
      cncContent: '',
      cncName: ''
    }
  },
  props: {
    selectedKey: {
      // 选择树节点
      type: String,
      default: ''
    },
    treeInfo: {
      type: Object,
      default: () => ({})
    },
    bottomUplod: {
      type: Number,
      default: 0
    }
  },
  watch: {
    selectedKey: {
      handler() {
        if (this.selectedKey.length) this.getCncData()
      },
      immediate: true,
      deep: true
    },
    bottomUplod: {
      handler() {
        if (this.selectedKey.length) this.getCncData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleCncDelete(record) {
      dasp.delCncFile(this.treeInfo.appCode, record.name, this.treeInfo.gateWayCode).then(() => {
        this.$message.success(this.$t('page_transport_directory_file_deleted_successfully'))
        this.getCncData()
      })
    },
    handleCncDownload(record) {
      const cncName = record.name
      dasp
        .readCncFile(this.treeInfo.appCode, record.name, this.treeInfo.gateWayCode)
        .then((res) => {
          let a = document.createElement('a')
          a.href = 'data:text/plain;charset=utf-8,' + res
          a.download = cncName
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
    },
    handleCncPrev(record) {
      this.cncName = record.name
      dasp
        .readCncFile(this.treeInfo.appCode, record.name, this.treeInfo.gateWayCode)
        .then((res) => {
          this.cncContent = res
          this.cncVisible = true
        })
    },
    closeCncPreview() {
      this.cncName = ''
      this.cncContent = ''
      this.cncVisible = false
    },
    handleDelete(record) {
      // tdfsp.delete(record.id).then(() => {
      //   this.$message.success(this.$t('page_transport_directory_file_deleted_successfully'))
      //   this.getData()
      // })
    },
    handleDownload(record) {
      downloadGET(record.objectKey, record.objectKey, record.contentType).then((res) => {
        downloadFile(res, record.originalFilename || record.fileName)
      })
    },
    handlePrev(record) {
      this.previewData = record
      this.previewVisible = true
    },
    closePreview() {
      this.previewData = {}
      this.previewVisible = false
    },
    async getCncData() {
      if (!this.treeInfo.appCode || !this.treeInfo.gateWayCode) {
        return
      }
      this.programList = []
      this.fileList = []
      this.loading = true
      console.log(typeof this.treeInfo.appCode)
      const res = await dasp.readCncFileList(this.treeInfo.appCode, this.treeInfo.gateWayCode)
      const data = res ? JSON.parse(res) : null
      if (data && data.fileList) {
        this.programList = data.fileList.map((res, index) => {
          const value = {
            id: index + '',
            fileType: res.type,
            name: res.name,
            contentLength: res.size
          }
          return value
        })
      }
      this.getScroll(this.programList, this.fileList)
      this.loading = false
    },
    getScroll(programList, fileList) {
      const programDiv = document.getElementById('program-content-list')
      if (programDiv) {
        const pheight = programList.length * 33
        if (pheight > programDiv.clientHeight - 48) {
          this.programScrollY = programDiv.clientHeight - 50
        } else {
          this.programScrollY = 0
        }
      }
      const fileDiv = document.getElementById('documents-content-list')
      if (fileDiv) {
        const fheight = fileList.length * 33
        if (fheight > fileDiv.clientHeight - 48) {
          this.fileScrollY = fileDiv.clientHeight - 50
        } else {
          this.fileScrollY = 0
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.cloud-path-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px;
  height: calc(100% - 38px);
  width: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;

  .program-content {
    background-color: #f8f8f8;
    border-radius: 2px;
    border: solid 1px #4a90e2;
    height: calc(100% - 4px);
    &-header {
      padding: 8px 16px;
      font-size: 16px;
      letter-spacing: 0px;
      background-color: #e6f7ff;
      color: #4a90e2;
      border-bottom: 1px solid #4a90e2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-tip {
        font-size: 12px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.85);
        .program-tip-type {
          color: #4a90e2;
        }
      }
    }
    &-list {
      padding: 8px;
      height: calc(100% - 41px);
      overflow-y: auto;
    }
    .program-content-file-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  .documents-content {
    background-color: #f8f8f8;
    border: solid 1px #13c2c2;
    border-radius: 2px;
    height: calc(50% - 4px);
    &-header {
      padding: 8px 16px;
      font-size: 16px;
      letter-spacing: 0px;
      background-color: #e6fffb;
      color: #13c2c2;
      border-bottom: 1px solid #13c2c2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-tip {
        font-size: 12px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.85);
        .documents-tip-type {
          color: #13c2c2;
        }
      }
    }
    &-list {
      padding: 8px;
      height: calc(100% - 41px);
      overflow-y: auto;
    }
    .documents-content-file-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
}
</style>
